export default __webpack_public_path__ + "static/media/menu-mobile-close.fdef9163.svg";